var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-dialog',{attrs:{"title":"请立即修改密码","value":!_vm.$store.state.user.changePwd,"showConfirmButton":false}},[_c('van-form',{ref:"form",staticClass:"pwd-form",on:{"submit":_vm.changeSubmit}},[_c('van-field',{attrs:{"label":"新密码","placeholder":"请输入新密码","type":"password","rules":[
      {
        required: true,
        message: '新密码不能为空',
        trigger: 'onBlur',
      },
      { min: 6, max: 20, message: '长度在 6 到 20 个字符' },
      { pattern: _vm.pattern, message: '不能包含非法字符' },
    ]},model:{value:(_vm.user.newPassword),callback:function ($$v) {_vm.$set(_vm.user, "newPassword", $$v)},expression:"user.newPassword"}}),_c('van-field',{attrs:{"label":"确认密码","placeholder":"请确认新密码","type":"password","rules":[
      { required: true, message: '新密码不能为空', trigger: 'onBlur' },
    ]},model:{value:(_vm.user.confirmPassword),callback:function ($$v) {_vm.$set(_vm.user, "confirmPassword", $$v)},expression:"user.confirmPassword"}}),_c('div',{staticClass:"pwd-tip"},[_vm._v("密码规则：字母+数字，不能少于6位。")]),_c('div',{staticStyle:{"margin":"16px"}},[_c('van-button',{attrs:{"type":"info","block":"","native-type":"submit"}},[_vm._v("确 定")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }